
import Vue from 'vue';
import Header from '@/components/Header/index.vue';
import ResultMessage from '@/components/ResultMessage/index.vue';
import { getUserGroup } from '@/utils';
import Link from './styles';

export default Vue.extend({
  components: {
    Header,
    Link,
    ResultMessage,
  },
  methods: {
    goHome(): void {
      this.$router.push(`${getUserGroup()}`);
    },
  },
});
